// Mock API Service Layer
// In production, replace these with actual API endpoints

// Browser-safe configuration - no process.env
const API_BASE_URL = 'https://api.citiplots.com/v1'

// Mock API responses with realistic delays
const mockDelay = (ms: number = 800) =>
  new Promise((resolve) => setTimeout(resolve, ms))

export const api = {
  // Authentication
  auth: {
    signup: async (data: any) => {
      await mockDelay()
      return {
        success: true,
        userId: 'user_' + Date.now(),
        message: 'OTP sent to email',
      }
    },
    verifyOTP: async (otp: string) => {
      await mockDelay()
      return { success: true, token: 'mock_jwt_token_' + Date.now() }
    },
    login: async (email: string, password: string) => {
      await mockDelay()
      return { success: true, token: 'mock_jwt_token', requires2FA: true }
    },
    verify2FA: async (code: string) => {
      await mockDelay()
      return { success: true, token: 'mock_jwt_token_verified' }
    },
  },

  // Listings
  listings: {
    getAll: async (filters?: any) => {
      await mockDelay()
      return { success: true, data: [], total: 0 }
    },
    getById: async (id: string) => {
      await mockDelay()
      return { success: true, data: {} }
    },
    create: async (data: any) => {
      await mockDelay()
      return { success: true, listingId: 'CP-' + Date.now() }
    },
    update: async (id: string, data: any) => {
      await mockDelay()
      return { success: true }
    },
  },

  // Reviews
  reviews: {
    getByListing: async (listingId: string) => {
      await mockDelay()
      return { success: true, data: [], averageRating: 4.5 }
    },
    create: async (data: any) => {
      await mockDelay()
      return { success: true, reviewId: 'rev_' + Date.now() }
    },
  },

  // Transactions
  transactions: {
    createOffer: async (data: any) => {
      await mockDelay()
      return { success: true, offerId: 'offer_' + Date.now() }
    },
    getById: async (id: string) => {
      await mockDelay()
      return { success: true, data: {} }
    },
    updateStatus: async (id: string, status: string) => {
      await mockDelay()
      return { success: true }
    },
  },

  // Payments
  payments: {
    createOrder: async (amount: number) => {
      await mockDelay()
      return { success: true, orderId: 'order_' + Date.now(), amount }
    },
    verifyPayment: async (paymentId: string) => {
      await mockDelay()
      return { success: true, verified: true }
    },
  },

  // Documents
  documents: {
    upload: async (file: File) => {
      await mockDelay(1500)
      return {
        success: true,
        fileId: 'doc_' + Date.now(),
        url: 'https://cdn.citiplots.com/docs/' + file.name,
      }
    },
    getSignedUrl: async (fileId: string) => {
      await mockDelay()
      return {
        success: true,
        url: 'https://cdn.citiplots.com/signed/' + fileId,
      }
    },
  },

  // Auctions
  auctions: {
    placeBid: async (auctionId: string, amount: number) => {
      await mockDelay()
      return { success: true, bidId: 'bid_' + Date.now() }
    },
    getBids: async (auctionId: string) => {
      await mockDelay()
      return { success: true, data: [] }
    },
  },

  // Profiles
  profiles: {
    get: async (userId: string) => {
      await mockDelay()
      return { success: true, data: {} }
    },
    update: async (data: any) => {
      await mockDelay()
      return { success: true }
    },
  },
}

export { API_BASE_URL }
